exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-view[data-v-d5c2c3b2] {\n  max-height: 12rem;\n}\n@media only screen and (min-width: 768px) {\n.list-view[data-v-d5c2c3b2] {\n    max-height: 450px;\n}\n}\n.list-view[data-v-d5c2c3b2] {\n  overflow-y: scroll;\n  min-width: 12rem;\n}\n.list-view li[data-v-d5c2c3b2]:hover {\n  cursor: pointer;\n  -webkit-filter: brightness(90%);\n          filter: brightness(90%);\n}", ""]);

// exports
